"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var firstValidValue = function firstValidValue() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  for (var _i = 0, _values = values; _i < _values.length; _i++) {
    var value = _values[_i];

    if (typeof value === 'number') {
      return value;
    }
  }
};

var getSpacingPropertyCreator = function getSpacingPropertyCreator(theme, spacingType, breakpoint) {
  return function () {
    for (var _len2 = arguments.length, directions = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      directions[_key2] = arguments[_key2];
    }

    return function (props) {
      var values = directions.map(function (direction) {
        return props["".concat(spacingType).concat(direction).concat(breakpoint)];
      });
      var value = firstValidValue.apply(void 0, (0, _toConsumableArray2["default"])(values));
      return value && value * theme.spacing(1);
    };
  };
};

var createSpacingRuleset = function createSpacingRuleset(theme, spacingType) {
  var _ref;

  var breakpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var createSpacingProperty = getSpacingPropertyCreator(theme, spacingType, breakpoint);
  return _ref = {}, (0, _defineProperty2["default"])(_ref, "".concat(spacingType, "Top"), createSpacingProperty('Top', 'TopBottom', '')), (0, _defineProperty2["default"])(_ref, "".concat(spacingType, "Right"), createSpacingProperty('Right', 'RightLeft', '')), (0, _defineProperty2["default"])(_ref, "".concat(spacingType, "Bottom"), createSpacingProperty('Bottom', 'TopBottom', '')), (0, _defineProperty2["default"])(_ref, "".concat(spacingType, "Left"), createSpacingProperty('Left', 'RightLeft', '')), _ref;
};

var styles = function styles(theme) {
  var _extends2;

  return {
    root: (0, _extends3["default"])({}, createSpacingRuleset(theme, 'margin'), createSpacingRuleset(theme, 'padding'), (_extends2 = {}, (0, _defineProperty2["default"])(_extends2, theme.breakpoints.up('sm'), (0, _extends3["default"])({}, createSpacingRuleset(theme, 'margin', 'SmallAndAbove'), createSpacingRuleset(theme, 'padding', 'SmallAndAbove'))), (0, _defineProperty2["default"])(_extends2, theme.breakpoints.up('md'), (0, _extends3["default"])({}, createSpacingRuleset(theme, 'margin', 'MediumAndAbove'), createSpacingRuleset(theme, 'padding', 'MediumAndAbove'))), (0, _defineProperty2["default"])(_extends2, theme.breakpoints.up('lg'), (0, _extends3["default"])({}, createSpacingRuleset(theme, 'margin', 'LargeAndAbove'), createSpacingRuleset(theme, 'padding', 'LargeAndAbove'))), (0, _defineProperty2["default"])(_extends2, theme.breakpoints.up('xl'), (0, _extends3["default"])({}, createSpacingRuleset(theme, 'margin', 'ExtraLargeAndAbove'), createSpacingRuleset(theme, 'padding', 'ExtraLargeAndAbove'))), _extends2))
  };
};

var _default = styles;
exports["default"] = _default;